import React from 'react';

interface SellerContractBatchExportModalProps {
  isOpen: boolean;
  year: number;
  current: number;
  total: number;
  currentName: string;
  isFinished: boolean;
  onCancel: () => void;
  onClose: () => void;
}

export function SellerContractBatchExportModal({
  isOpen,
  year,
  current,
  total,
  currentName,
  isFinished,
  onCancel,
  onClose,
}: SellerContractBatchExportModalProps): React.ReactElement | null {
  if (!isOpen) return null;

  const percent = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      role="dialog"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', zIndex: 1050 }}
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 540 }}>
        <div className="modal-content" style={{ borderRadius: 8, boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }}>
          <div
            className="modal-header"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '14px 20px',
              borderBottom: '1px solid #e9ecef',
            }}
          >
            <h5 className="modal-title" style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>
              <i className="fas fa-file-export text-danger" style={{ marginRight: 8 }}></i>
              Exporting All Contracts ({year})
            </h5>
            {isFinished && (
              <button
                type="button"
                className="close"
                onClick={onClose}
                style={{ fontSize: 22, background: 'none', border: 'none', cursor: 'pointer', outline: 'none' }}
              >
                &times;
              </button>
            )}
          </div>

          <div className="modal-body" style={{ padding: '24px 20px' }}>
            <div style={{ marginBottom: 15 }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 6,
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                <span>{isFinished ? 'Completed' : 'Sequential Exporting Progress'}</span>
                <span>
                  {current} / {total} ({percent}%)
                </span>
              </div>

              <div className="progress" style={{ height: 22, borderRadius: 11, backgroundColor: '#e9ecef' }}>
                <div
                  className={`progress-bar ${
                    isFinished ? 'bg-success' : 'progress-bar-striped progress-bar-animated bg-danger'
                  }`}
                  role="progressbar"
                  style={{ width: `${percent}%`, transition: 'width 0.3s ease', fontSize: 12, fontWeight: 700 }}
                  aria-valuenow={percent}
                  aria-valuemin={0}
                  aria-valuemax={100}
                >
                  {percent}%
                </div>
              </div>
            </div>

            <div
              style={{
                fontSize: 13,
                color: '#495057',
                padding: '10px 14px',
                backgroundColor: '#f8f9fa',
                borderRadius: 6,
                border: '1px solid #e9ecef',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
              }}
            >
              {!isFinished ? (
                <i className="fas fa-spinner fa-spin text-danger" style={{ fontSize: 16 }}></i>
              ) : (
                <i className="fas fa-check-circle text-success" style={{ fontSize: 16 }}></i>
              )}
              <span style={{ wordBreak: 'break-word', fontWeight: 500 }}>
                {currentName || 'Preparing PDF export...'}
              </span>
            </div>

            {!isFinished && (
              <div style={{ marginTop: 12, fontSize: 12, color: '#6c757d', textAlign: 'center' }}>
                <i className="fas fa-info-circle" style={{ marginRight: 4 }}></i>
                PDF files are downloaded one-by-one with a small delay to prevent browser download restrictions.
              </div>
            )}
          </div>

          <div className="modal-footer" style={{ padding: '12px 20px', borderTop: '1px solid #e9ecef' }}>
            {!isFinished ? (
              <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>
                <i className="fas fa-stop" style={{ marginRight: 5 }}></i> Stop / Cancel Export
              </button>
            ) : (
              <button type="button" className="btn btn-primary btn-sm" onClick={onClose}>
                Done
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
